/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
// Common
import FadeIn from "../../common/FadeIn";
//Packages
import axios from "axios";
import { Row, Col, Button, Form } from "react-bootstrap";

const TutorAddForm = (props) => {
  const [First_Name, setFirst_Name] = useState("");
  const [Last_Name, setLast_Name] = useState("");
  const [email, setEmail] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      First_Name,
      Last_Name,
      email,
    };
    // Make the API call
    const requestNewTutor = await axios.post("/api/admin/manage/tutor", data, {
      withCredentials: true,
    });
    if (requestNewTutor.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully saved tutor.");
      window.scrollTo(10, 0);
      props.setViewMode("view");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row>
      <Col sm='12'>
        <FadeIn delay={50} duration={450}>
          <div className='mx-1 mt-3 p-2 shadow text-center border'>
            <Form className='post' onSubmit={handleSubmit}>
              <Row>
                <Col sm='6' className='mt-2'>
                  <Form.Group controlId='TutorNameForm'>
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type='text'
                      maxLength='256'
                      placeholder='Tutor First Name'
                      value={First_Name}
                      onChange={(e) => setFirst_Name(e.target.value)}
                      required
                      className='border'
                    />
                    <Form.Text className='text-muted'>The tutors first name.</Form.Text>
                  </Form.Group>
                </Col>
                <Col sm='6' className='mt-2'>
                  <Form.Group controlId='TutorNameForm'>
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type='text'
                      maxLength='256'
                      placeholder='Tutor Last Name'
                      value={Last_Name}
                      onChange={(e) => setLast_Name(e.target.value)}
                      required
                      className='border'
                    />
                    <Form.Text className='text-muted'>The tutors last name.</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className='mt-2'>
                  <Form.Group controlId='LessonTitleForm' className='mt-3'>
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      value={email}
                      onChange={(e) => setEmail(e.target.value.toLowerCase())}
                      required
                      style={{ textTransform: "lowercase" }}
                      type='email'
                      className='border'
                    />
                    <Form.Text className='text-muted'>
                      ATTENTION: the tutor user is not automatically sent a password. You can trigger them a password reset email with the password reset button against the tutor user, or they can request it themselves.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Col className='mt-2 mb-2'>
                <Button variant='primary' type='submit' disabled={props.submitClicked}>
                  Create Tutor
                </Button>
              </Col>
            </Form>
          </div>
        </FadeIn>
      </Col>
    </Row>
  );
};

export default TutorAddForm;
